import _ from "lodash";
import {push} from "react-router-redux";
import {buildQuery, parseQuery} from "utils/uri";

function normaliseSearch(search: string) {
  return search.replace(/%3A/gi, ":");
}

function updateUrlParamsWithDispatch(
  pairs: Record<string, unknown | undefined | null>,
  dispatch: (args: unknown) => unknown,
) {
  const {pathname, search} = location;
  const params = parseQuery(search);

  const newSearch = buildQuery(
    _.omit(
      {...params, ...pairs},
      Object.keys(pairs).filter(key => !pairs[key]),
    ),
  );

  if (normaliseSearch(search) !== normaliseSearch(newSearch)) {
    dispatch(push(pathname + newSearch));
  }
}

export default updateUrlParamsWithDispatch;
